import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 4px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  width: 20px;
  height: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 0.5px solid ${({ theme }) => theme.colors.black5};
  background: ${({ theme }) => theme.colors.black1};
  box-shadow: 1px 2px 0px 0px ${({ theme }) => theme.colors.black10};
`;
